import React, { useEffect, useState } from "react";
import useStyles from '../maintenance/assets/styles';
import { Grid, Typography } from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";
import { fetchBatchNumbers, getAllDevices, getDeviceIdsbyBatchNumbers, getDevices } from "../maintenance/test-automation/components/apiHelper";
import { MultiSelectDropDown } from "../maintenance/test-automation/components/MultiSelectDropDown";
import { set } from "date-fns";
import { BatchSelectDropDown } from "./components/BatchSelectDropDown";

export const SelectTestDeviceComponent = (props) => {
    const classes = useStyles();
    const [devices, setDevices] = useState([]);

    useEffect(() => {
        const loadDevices = async () => {
            if (props.selectedBatches.length > 0) {
                props.setLoading(true);
                try {
                    const deviceIds = await getDeviceIdsbyBatchNumbers(props.selectedBatches);
                    const devicesResponse = await getAllDevices(deviceIds);
                    
                    setDevices(devicesResponse || []);
                } catch (err) {
                    console.error("Failed to fetch devices:", err);
                    setDevices([]);
                } finally {
                    props.setLoading(false);
                }
            }
        };
        
        loadDevices();
    }, [props.selectedBatches]);

    const handleBatchSelection = async (selectedBatches) => {
        props.handleSelectBatchNumber(selectedBatches);
        
        if (selectedBatches.length === 0) {
            setDevices([]);
            return;
        }
        
        props.setLoading(true);
        try {
            const deviceIds = await getDeviceIdsbyBatchNumbers(selectedBatches);
            const devicesResponse = await getAllDevices(deviceIds);
            
            // Preserve selection state when changing batches
            const devicesWithSelection = (devicesResponse || []).map(device => ({
                ...device,
                isSelected: props.selectedDevices.includes(device.id)
            }));
            
            setDevices(devicesWithSelection);
        } catch (err) {
            console.error("Failed to fetch devices:", err);
            setDevices([]);
        } finally {
            props.setLoading(false);
        }
    };

    return (
        <>
            <Grid container alignItems="center" style={{ marginTop: "15px" }}>
                <Grid item xs={12} style={{marginBottom: "20px"}}>
                    <Grid item xs={12} md={12}>
                        <Typography className={classes.typo}>
                        Batch
                        <span style={{ color: 'red' }}>*</span>
                        </Typography> 
                    </Grid>
                    <BatchSelectDropDown
                        batchNumbers={props.batchNumbers}
                        emptyTag="Select Batch"
                        selectedBatches={props.selectedBatches}
                        handleSelectBatchNumber={handleBatchSelection}
                    />
                    {props.errors.batchNumberError &&
                        <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                            {props.errors.batchNumberError}
                        </Typography>
                    }
                </Grid>
                <Grid item xs={12} style={{marginBottom: "10px"}}>
                    <MultiSelectDropDown
                        options={devices}
                        setSelectedDevices={props.setSelectedDevices}
                        selectedDevices={props.selectedDevices}
                        handleSave={props.handleSave}
                        handleCancel={props.handleCancel}
                        type='devices'
                        errors={props.errors}
                        setErrors={props.setErrors}
                        isBatch={true}
                        selectedBatches={props.selectedBatches}
                        formType={props.formType}
                    />
                </Grid>
            </Grid>
        </>
    )
}